import { render, staticRenderFns } from "./EmployeeRestingWidget.vue?vue&type=template&id=355789e3&"
import script from "./EmployeeRestingWidget.vue?vue&type=script&lang=js&"
export * from "./EmployeeRestingWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports